export enum ReportDataType {
  RETURNED_LINE_ITEMS = "returned_products",
  RETURNS = "returns",
  WARRANTY_CUSTOMERS = "warranty_customers",
  PURCHASED_EXTENDED_WARRANTY = "purchased_extended_warranty",
  BILLING_CHARGES = "billing_charges",
}
